import React from 'react';
import { render } from 'react-dom';

import ReactApp from './reactApplication';

render(<ReactApp />, document.getElementById('j-application'));



// WEBPACK FOOTER //
// ./index.js